<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <router-link to="/">
              Transpo
            </router-link>
          </li>
          <li>
            <router-link to="/about">
              About Us
            </router-link>
          </li>
          <li>
            <router-link to="/terms-of-use">
              Terms of Use
            </router-link>
          </li>
          <li>
            <router-link to="/privacy-policy">
              Privacy Policy
            </router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}
        <a href="https://www.transpoindia.in" target="_blank" rel="noopener"
          >Transpo</a
        >
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
